import { useTranslation } from 'react-i18next';
import { getFormattedDate } from 'dateUtils';
import { getDayDiff } from '../utils';

const RELATIVE_DUE_DATE_DAY_LIMIT = 14;

const useRfiDueDateDisplay = (dueDate: Date | string) => {
  const { t } = useTranslation();

  if (!dueDate) return '/';

  const diffInDays = getDayDiff(dueDate);

  if (diffInDays === 0) return t('today');

  if (Math.abs(diffInDays) > RELATIVE_DUE_DATE_DAY_LIMIT)
    return getFormattedDate(new Date(dueDate));

  return diffInDays > 0
    ? t('day_future', { count: diffInDays })
    : t('expiredDaysAgo', { count: Math.abs(diffInDays) });
};

export default useRfiDueDateDisplay;
